export class SetCollectionsLoadingStatus {
    public static readonly type = '[JobsPlacements] Set collections loading status';
}
